import {Component, OnInit} from '@angular/core';

import {MainMenuItem} from './main-menu-item';
import {MainMenuService} from './main-menu.service';
import {User} from '../../model/types';
import {AuthService} from '../../service';
import {Router} from '@angular/router';
import {AuthNewService} from '../../service/auth-new.service';
import { delay} from 'rxjs/operators';
import { StorageService } from '../../service/storage.service';

@Component({
    selector: 'main-menu',
    templateUrl: 'main-menu.component.html',
    styleUrls: ['main-menu.component.scss']
})
export class MainMenuComponent implements OnInit  {
    mainMenuItems?: MainMenuItem[];
    signedInUser: any;
    constructor(private authService: AuthService,
        private AuthService: AuthNewService,
                private router: Router,
                private mainMenuService: MainMenuService,
            private storageservice:StorageService) {
    }

    getMainMenuItems(): void {
        const OBSERVER = {
            next: (x:any )=> {
                this.mainMenuItems = x;
            }
        };
        this.mainMenuService.getData()?.subscribe(OBSERVER);
    }

    ngOnInit(): void {
         const access = this.storageservice.get('access');
            this.getMainMenuItems();


    }

    toggle(event: Event, item: any, el: any) {
        event.preventDefault();

        const items: any[] = el.mainMenuItems;

        if (item.active) {
            item.active = false;
        } else {
            for (let i = 0; i < items.length; i++) {
                items[i].active = false;
            }
            item.active = true;
        }
    }
}
